// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";

const name = "gaussianSplattingSortScatterComputeShader";
const shader = `struct Params {count : u32,
paddedCount : u32,
numBuckets : u32,
pad : u32,
coeff : vec4f,};@group(0) @binding(0) var<storage,read> bucket : array<u32>;@group(0) @binding(1) var<storage,read> seed : array<f32>;@group(0) @binding(2) var<storage,read_write> offsets : array<atomic<u32>>;@group(0) @binding(3) var<storage,read_write> sortedIndex : array<f32>;@group(0) @binding(4) var<uniform> params : Params;@compute @workgroup_size(256,1,1)
fn main(@builtin(global_invocation_id) gid : vec3u) {let i=gid.x;if (i>=params.paddedCount) {return;}
if (i>=params.count) {sortedIndex[i]=0.0;return;}
let b=bucket[i];let dst=atomicAdd(&offsets[b],1u);sortedIndex[dst]=seed[i];}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}

/** @internal */
export const gaussianSplattingSortScatterComputeShaderWGSL = { name, shader };
